module.exports = __webpack_public_path__ + "img/network4.7544d6fe.png";